import { SQLite } from "@ionic-native/sqlite";
import { isPlatform } from "@ionic/react";

var dbConfigAndroid = {
  name: "sbos_photo_uploader.db",
  location: "default",
  androidDatabaseProvider: 'system'
}

var dbConfigIos = {
  name: "sbos_photo_uploader.db",
  location: "default",
}

export const getDbConfig = () => {
  if (isPlatform('ios')) {
    return dbConfigIos;
  } else {
    return dbConfigAndroid;
  }
}

// functions for sqlite database handling
export const initializeDB = async () => {
  try {
    const dbcon = SQLite.create(getDbConfig());
    await dropAllTables();
    await createAllTables();
    return dbcon;
  } catch (e) {
    console.error("please use a device: ", e);
  }
};

export const closeDb = async (dbCon) => {
  if (dbCon && dbCon.close) {
    await dbCon.close();
  }
}

export const openDb = async () => {
  return SQLite.create(getDbConfig());
};

const createTable = async (tableDeails) => {
  try {
    const dbcon = await openDb();
    await dbcon.executeSql("CREATE TABLE IF NOT EXISTS " + tableDeails, []);
  } catch (e) {
    console.error("SQL error: ", e);
  }
};

const dropTable = async (tableName) => {
  try {
    const dbcon = await openDb();
    const drop = await dbcon.executeSql("DROP TABLE IF EXISTS " + tableName, []);
    return createResponseBody(drop, "200");
  } catch (error) {
    console.error(error);
    return createResponseBody(error, "500", error.message);
  }
};

export const deleteFromTable = async (tableName) => {
  try {
    const dbcon = await openDb();
    const drop = await dbcon.executeSql("DELETE FROM `" + tableName + "` ", []);
    return createResponseBody(drop, "200");
  } catch (error) {
    console.error(error);
    return createResponseBody(error, "500", error.message);
  }
};

const createAllTables = async () => {
  console.log(" ***** CREATE ALL TABLES ***** ");
  await createTable("offline_changes(id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT, apiUrlPrefix VARCHAR(128), requestBody TEXT)");
  await createTable("uploaded_photos(id INTEGER NOT NULL PRIMARY KEY AUTOINCREMENT, imageData TEXT, created TEXT )");
  await createTable("settings (s_key TEXT UNIQUE, s_value TEXT)");
};

const dropAllTables = async () => {
  console.log(" ***** DROP ALL TABLES ***** ");
  await dropTable("settings");
  await dropTable("uploaded_photos");
};


export const executeQuery = async (queryString, valuesArray = []) => {
  try {
    const dbcon = await openDb();
    const value = await dbcon.executeSql(queryString, valuesArray);
    console.log('executeQuery', value);
    return createResponseBody(value, "200");
  } catch (error) {
    console.error(error);
    return createResponseBody(error, "500", error.message);
  }
};


export const replaceUploadedPhotos = async (imagesData = [], created) => {
  try {
    const dbcon = await openDb();
    await dbcon.executeSql("DELETE FROM uploaded_photos WHERE created = ?", [created]);
    const params = [];
    let query = "INSERT INTO uploaded_photos ( imageData, created) values "
    for (let i = 0; i < (imagesData?.length); i++) {
      params.push(JSON.stringify(imagesData[i]));
      params.push(created)
      query = query + " (?,?)" + ((i < imagesData.length - 1) ? "," : "");
    }
    const result = await dbcon.executeSql(query, params);
    return createResponseBody(result, "200");
  } catch (error) {
    console.error(error);
    return createResponseBody(error, "500", error.message);
  }
}

export const getUploadedPhotos = async () => {
  try {
    const dbcon = await openDb();
    let select = await dbcon.executeSql("SELECT imageData FROM uploaded_photos ", []);
    const result = [];
    if (select?.rows?.length > 0) {
      try {

        for (let i = 0; i < select.rows.length; i++) {
          result.push(JSON.parse(select.rows.item(i).imageData));
        }
      } catch (e) {
        console.error(e);
      }
    }
    return createResponseBody(result, "200");
  } catch (error) {
    console.error(error);
    return createResponseBody(error, "500", error.message);
  }
}

export const insertOfflineChanges = async (apiUrlPrefix, requestBody) => {
  return await executeQuery("INSERT INTO offline_changes (apiUrlPrefix , requestBody) values (?,?,?)", [apiUrlPrefix, requestBody]);
};

export const insertOfflineChangesMultipleValues = async (valuesQuery) => {
  return await executeQuery("INSERT INTO offline_changes (apiUrlPrefix , requestBody) VALUES " + valuesQuery);
};

export const deleteOfflineChangesByPrefix = async (apiUrlPrefix) => {
  console.log({apiUrlPrefix})
  return await executeQuery("DELETE FROM `offline_changes` WHERE apiUrlPrefix = ? ", [apiUrlPrefix]);
};

export const getOfflineChangesByUrlPrefix = async (apiUrlPrefix) => {
  return await executeQuery("SELECT * FROM offline_changes WHERE apiUrlPrefix = ? ORDER BY id ASC ", [apiUrlPrefix]);
};

export const saveOrUpdateSettings = async (values) => {
  let queryStr = "INSERT or REPLACE INTO settings (s_key,s_value) VALUES (?,?) ";
  if (values)
    for (var v of values) {
      await executeQuery(queryStr, [v['s_key'], v['s_value']]);
    }
  // update the last updated timestamp
  await executeQuery(queryStr, ["lastUpdatedTs", new Date().getTime()]);
};

export const getSavedSetting = async (key) => {
  let res = await executeQuery("SELECT s_value FROM settings WHERE s_key = ? ", [key]);
  if (res.rows.length > 0) {
    return (await res.rows.item(0)) ? JSON.parse(res.rows.item(0).s_value) : null;
  }
  return null;
};

export const getAllSavedSettings = async () => {
  let res = await executeQuery("SELECT s_key,s_value FROM settings ", []);
  let responseObj = {};
  for (let i = 0; i < res.rows.length; i++) {
    const item = await res.rows.item(i);
    if (item['s_key'])
      responseObj[item['s_key']] = item['s_value'];
  }
  return responseObj;
};

const createResponseBody = (sqlReturnedObj, statusCode, msg = "") => {
  sqlReturnedObj.response = { status: statusCode, offline: true, msg };
  return sqlReturnedObj;
}

export const cleanUpLocalDatabase = async () => {
  try {
    console.log("**** CleanUpLocalDatabase *****")
    const nrOfOldDays = 14;
    const installations_query = "DELETE FROM uploaded_photos WHERE created <= date('now','-" + nrOfOldDays + " day'); ";
    
    const all_queries = installations_query;
    const result = await executeQuery(all_queries, []);
    console.log({ result })
  } catch (error) {
    console.error(error);
  }
};